import React from 'react';
import cx from 'classnames';
import Label from '../../shared/components/I18n/Label';
import { SportAllLink } from '../../shared/components/Sport/SportLinks';
import useTranslate from '../../shared/components/I18n/Interpreter';

const TournamentNothingFound = ({ selectedSport = null, className = null }) => {
  const t = useTranslate();

  const classes = cx(
    'sport-page__content sport-page__content--nothing-found tournament--nothing-found animate-fade-left-in',
    className,
  );

  if (!selectedSport) {
    return (
      <div className={classes}>
        <h3 className='nothing-found'>
          <Label message='nothing_found' />
        </h3>
      </div>
    );
  }

  return (
    <div className={classes}>
      <h3 className='nothing-found'>
        <Label message='nothing_found' />
      </h3>

      <p className='nothing-found-label'>
        <Label message='no_tournament_found' />
      </p>

      <SportAllLink sportUrlName={selectedSport?.urlName} className='go-to-link'>
        {`${t('go_to')} ${t('all')} ${selectedSport?.name}`}
      </SportAllLink>
    </div>
  );
};

export default TournamentNothingFound;
